var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-list--row"},[_c('div',{staticClass:"row row--1"},[_vm._t("col-title")],2),_c('div',{staticClass:"row row--2"},[_vm._t("col-value")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }